import { Edit } from '@mui/icons-material'
import { Button, Card, CardContent, CircularProgress, Grid, Typography, Divider } from '@mui/material'
import { ExplanationAccordion, LabelField } from 'components'
import * as controllers from 'controllers'
import { SettingsMissingOhioTitleAlertDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import MissingOhioTitleAlertDateAddEditDialog from './MissingOhioTitleAlertDateAddEditDialog'

export default function MissingOhioTitleAlertDateListCard() {
  const [isGettingMissingOhioTitleAlertDate, setIsGettingMissingOhioTitleAlertDate] = useState<boolean>(false)
  const [isMissingOhioTitleAlertDateSaving, setIsMissingOhioTitleAlertDateSaving] = useState<boolean>(false)
  const [missingOhioTitleAlertDateAddEditDialogOpen, setMissingOhioTitleAlertDateAddEditDialogOpen] = useState<boolean>(false)
  const [missingOhioTitleAlertDate, setMissingOhioTitleAlertDate] = useState<SettingsMissingOhioTitleAlertDto>(
    new SettingsMissingOhioTitleAlertDto()
  )

  useEffect(() => {
    setIsGettingMissingOhioTitleAlertDate(true)
    controllers
      .getMissingOhioTitleAlertDate()
      .then(response => {
        setMissingOhioTitleAlertDate(response.value)
      })
      .finally(() => {
        setIsGettingMissingOhioTitleAlertDate(false)
      })
  }, [])

  return (
    <>
      <MissingOhioTitleAlertDateAddEditDialog
        initialValues={missingOhioTitleAlertDate}
        isLoading={isMissingOhioTitleAlertDateSaving}
        onClose={() => {
          setMissingOhioTitleAlertDateAddEditDialogOpen(false)
        }}
        onSave={values => {
          setIsMissingOhioTitleAlertDateSaving(true)
          controllers
            .updateMissingOhioTitleAlertDate(values)
            .then(response => {
              enqueueSnackbar('Missing Ohio Title Alert Date Successfully Saved!', { variant: 'success' })
              setMissingOhioTitleAlertDate(response.value)
              setMissingOhioTitleAlertDateAddEditDialogOpen(false)
            })
            .finally(() => {
              setIsMissingOhioTitleAlertDateSaving(false)
            })
        }}
        open={missingOhioTitleAlertDateAddEditDialogOpen}
      />

      <Card>
        <CardContent>
          <Grid container spacing={1} alignItems='flex-start'>
            <Grid item xs={12} container alignItems='center' justifyContent='space-between'>
              <Grid item xs={12} sm='auto'>
                <Typography fontWeight='bold' variant='h5'>
                  Missing Ohio Title Alert Date
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto'>
                <Button
                  onClick={() => {
                    setMissingOhioTitleAlertDateAddEditDialogOpen(true)
                  }}
                  variant='text'
                  endIcon={<Edit />}
                >
                  EDIT
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Divider />
            </Grid>

            {isGettingMissingOhioTitleAlertDate && (
              <Grid item container alignItems='center' justifyContent='center' sx={{ my: 1 }}>
                <Grid>
                  <CircularProgress color='primary' size={50} />
                </Grid>
              </Grid>
            )}

            {!isGettingMissingOhioTitleAlertDate && (
              <Grid item xs={12}>
                <LabelField
                  label='Number of Days After Title Applications Delivered Ohio'
                  value={missingOhioTitleAlertDate.missingOhioTitleAlertNumberOfDaysAfterTitleApplicationsDeliveredOhio}
                />
              </Grid>
            )}

            <Grid item xs={12}>
              <ExplanationAccordion variant='outlined'>
                ||After Ohio title application boxes are delivered to Ohio (this may be driven off the FedEx API saying the box
                was delivered to Ohio), where the Title has not been added to the vehicle (the Ohio title is mailed to the
                Registered Importer, the Ohio title is OCR’d and associated with the VIN) send an alert email to all VTS2 users
                with the Receives “Missing Ohio Title” emails VTS2 Access. This is to prevent the need for manual tracking of
                this information outside VTS2. ||
              </ExplanationAccordion>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}
